/***************************************************
Alexander Self
7/22/19
Root reducer: Combines all cultivation reducers
****************************************************/
import { combineReducers } from 'redux';
import ChemicalReducer from './chemical_reducer';
import ReportReducer from './report_reducer';
import UtilsReducer from './utils_reducer';
import ChemicalApplicationReducer from './chem_app_reducer';
import FertilizerReducer from './fertilizer_reducer';
import MowingReducer from './mowing_reducer';
import TreeInventoryReducer from './tree_inventory_reducer';
import TreeReplantReducer from './tree_replant_reducer';

const cultivationReducer = combineReducers({
  chemical: ChemicalReducer,
  chemApp: ChemicalApplicationReducer,
  fertilizer: FertilizerReducer,
  mowing: MowingReducer,
  report: ReportReducer,
  treeInventory: TreeInventoryReducer,
  treeReplant: TreeReplantReducer,
  utils: UtilsReducer
});

export default cultivationReducer;



// WEBPACK FOOTER //
// ./src/cultivation/reducers/index.js